import React, { useContext, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "./Button";
import { AuthContext } from "../AuthContext";
import { toast } from "react-hot-toast";

export default function AuthButtons({ buttons = [], className = "" }) {
  const { user, logoutUser, loading, initialized } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const fullName = [user?.first_name, user?.last_name]
    .filter(Boolean)
    .join(" ");
  const email = user?.email || "";

  const handleToggle = () => setOpen((o) => !o);
  const handleClose = () => setOpen(false);

  const handleLogout = async () => {
    await logoutUser();
    toast.success("Déconnecté");
    navigate("/login");
    handleClose();
  };

  // Ne rien afficher pendant l'initialisation
  if (!initialized) {
    return <div className={`hidden md:flex items-center gap-2 ${className}`} />;
  }

  return (
    <div className={`hidden md:flex items-center gap-2 ${className}`}>
      {user ? (
        <div className="relative" ref={menuRef}>
          <button
            onClick={handleToggle}
            className="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            {/* Icône d'avatar */}
            <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            {/* Flèche dropdown */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={`transition-transform ${open ? "rotate-180" : ""}`}
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          {open && (
            <div
              className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-md border border-[#0000001A] z-50"
              onMouseLeave={handleClose}
            >
              <div className="px-4 py-3 border-b border-[#0000001A]">
                <p className="text-sm font-bold text-[#1B1C33] truncate">
                  {fullName || "Utilisateur"}
                </p>
                {email && (
                  <p className="text-xs text-[#6B7280] truncate">{email}</p>
                )}
              </div>
              <div className="py-1">
                <Link
                  to="/profile"
                  className="flex items-center gap-2 px-4 py-2 text-sm text-[#1B1C33] hover:bg-gray-50"
                  onClick={handleClose}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1B1C33"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  Voir le profil
                </Link>
                {/* <Link
                  to="/welcome"
                  className="flex items-center gap-2 px-4 py-2 text-sm text-[#1B1C33] hover:bg-gray-50"
                  onClick={handleClose}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1B1C33"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="4" width="18" height="14" rx="2" />
                    <path d="M3 10h18" />
                  </svg>
                  Voir les apps
                </Link>
                <Link
                  to="/"
                  className="flex items-center gap-2 px-4 py-2 text-sm text-[#1B1C33] hover:bg-gray-50"
                  onClick={handleClose}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1B1C33"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0h6" />
                  </svg>
                  Revenir à la Landing Page
                </Link> */}
                <button
                  type="button"
                  onClick={handleLogout}
                  disabled={loading}
                  className="w-full text-left flex items-center gap-2 px-4 py-2 text-sm text-[#1B1C33] hover:bg-gray-50 disabled:opacity-60"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1B1C33"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  {loading ? "Déconnexion..." : "Se déconnecter"}
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        buttons.map((button) => (
          <Button
            key={button.id}
            as={Link}
            to={button.to}
            variant={button.variant}
          >
            {button.label}
          </Button>
        ))
      )}
    </div>
  );
}
